export function getToolCategoryHref(slug) {
  return `/tools/${slug === 'personal-growth' ? '' : slug}`;
}
export function getToolHref(slug) {
  return `/tools/tests/${slug}`;
}

export function getTheoryHref(slug) {
  const base = '/theory';
  return slug && slug !== 'introduction' ? `${base}/${slug}` : base;
}

export function getInvitationLink(id) {
  const host = process.env.NEXT_PUBLIC_HOST || '';
  return `${host}/teams/join/${id}`;
}

export function getPersonalityTypeHref(slug) {
  const base = '/personality-type';
  return slug ? `${base}/${slug}` : base;
}

export function getCheckoutHref(slug) {
  return slug ? `/checkout/${slug}` : '/pricing';
}

export const getPriceCardHref = ({
  isUserLoaded,
  isAuthorized,
  hasSubscriptions,
  slug,
}) => {
  if (!isUserLoaded) {
    return getCheckoutHref(slug);
  }
  if (!isAuthorized) {
    return '/login';
  }
  if (hasSubscriptions) {
    return '';
  }
  return getCheckoutHref(slug);
};

export function getPersonalityArticleHref(slug, parentType) {
  return `${getPersonalityTypeHref(parentType)}${
    slug === 'introduction' || !slug ? '' : `/${slug}`
  }`;
}

export function getBlogTopicHref(slug) {
  return `/blog/${slug}`;
}

export function getArticleHref(slug, { isLanding = false } = {}) {
  return isLanding ? `/blog/${slug}` : `/blog/article/${slug}`;
}

export function getAuthorHref(slug) {
  return `/blog/author/${slug}`;
}

export function getCategoryHref(slug) {
  return `/blog/category/${slug}`;
}

export function generateHref(slug, type, parentType = '') {
  if (type?.endsWith('BlogPost')) {
    return getArticleHref(slug, { isLanding: true });
  }
  if (type?.endsWith('PersonalityPost')) {
    return `/posts${slug === 'introduction' || !slug ? '' : `/${slug}`}`;
  }
  if (type?.endsWith('PrivacyPolicy')) {
    return '/privacy';
  }
  if (type?.endsWith('TermsConditions')) {
    return '/terms-conditions';
  }
  switch (type) {
  case 'blogPost':
    return getArticleHref(slug);
  case 'toolCategory':
    return getToolCategoryHref(slug);
  case 'tool':
    return getToolHref(slug);
  case 'personalityType':
    return getPersonalityTypeHref(slug);
  case 'personalityArticle':
    return getPersonalityArticleHref(slug, parentType);
  case 'blogTopic':
    return getBlogTopicHref(slug);
  case 'teamInvitation':
    return getInvitationLink(slug);
  case 'theoryPost':
    return getTheoryHref(slug);
  case 'faq':
    return '/faq';
  case 'privacyPolicy':
    return '/privacy';
  case 'aboutUs':
    return '/about-us';
  case 'premium':
    return '/premium';
  case 'termsConditions':
    return '/terms-conditions';
  case 'pricePlan':
    return '/pricing';
  default:
    return '/';
  }
}
